export const testIds = {
  root: 'Pagination_Root',
  navButtonFirst: 'Pagination_NavButton_First',
  navButtonLast: 'Pagination_NavButton_Last',
  navButtonPrev: 'Pagination_NavButton_Prev',
  navButtonNext: 'Pagination_NavButton_Next',
};
